/**
 * @param dateStr 2024-07-08 03:03:05
 * @to 1720404185000
 */
export function DateToMilliseconds(dateStr: string): number {

    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    const date = new Date(year, month - 1, day, hours, minutes, seconds);
    return date.getTime();
}

export function ConvertTimestamp (timestamp: string) {
    const date = new Date(timestamp);

    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        date: date.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds()
    };
}

export function SecondsToTime(seconds: number){

    let h = Math.floor(seconds / 3600).toString().padStart(2,'0'),
        m = Math.floor(seconds % 3600 / 60).toString().padStart(2,'0'),
        s = Math.floor(seconds % 60).toString().padStart(2,'0');

    return h + ':' + m + ':' + s;
}

/**
 * @param inputDate: "DD-MM-YYYY HH:mm"
 * @output inputDate: "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
 */
export function TransformDate(inputDate: string): string {
    const [datePart, timePart] = inputDate.split(' ');
    const [day, month, year] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    // Create a new Date object with the parsed components in UTC
    const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute)));

    return date.toISOString().slice(0, 19) + ".000000Z";
}

export function FormatDate(dateString: string) {

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return "Date invalide";
    }

    return date.toLocaleString("fr-FR", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
}

export function FormatDateToCA(inputDate: string, hiddenTime?: boolean): string {

    const date = new Date(inputDate);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    if (hiddenTime) return `${day}-${month}-${year}`;
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}